import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicSugarMetabolismCombined from "./index";

const CardiometabolicSugarMetabolismWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicSugarMetabolismCombined}
    keyControlsId="cardiometabolic-sugar-metabolism-key"
    {...props}
  />
);

export default CardiometabolicSugarMetabolismWithToggleKey;
